//import packages from node modules
import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { reduxForm, Field } from 'redux-form'

//import shared components
import SolidButton from '../../shared/button/solidbutton'
import OutlinedButton from '../../shared/button/outlinedbutton'
import Loading from '../../shared/loading'
import TextField from '../../shared/form/textfield'
import Goback from '../../shared/goback'

//import utility functions
import {
  requiredFieldValidation,
  emailFieldValidation,
  phonenumberValidation,
  passwordValidation,
  AU_NZ_phone_validation
} from '../../shared/form/validation'
import globalCookies from '../../../utilities/function/cookies'
import {
  addClassToDOM,
  removeClassToDOM
} from '../../../utilities/function/common'

import {
  getCartToken
} from '../../../utilities/function/cartToken'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse,
  isResponseCancelled,
} from "../../../utilities/function/apiResponse"

import {
  getAppConfigValue,
  getAttributes
} from "../../../utilities/function/configuration"

import {
  getDataFromURL
} from "../../../utilities/function/urlparams"

import ACCOUNT_API, { cancelCheckToken, cancelAddEmail } from '../../../utilities/api/account'

import {
  ACCOUNT_ERROR,
  ACCOUNT_LOADING,
  ACCOUNT_SUCCESS,
  appInit,
  logoutApp,
  updatePopupNotification
} from '../../../app/action'

//main component
let Initial = (props) => {
  const { history } = props
  const createAccountCallback = (e) => {
    e.preventDefault()
    history.push(`${history.location.pathname}?a=checkout&step=account&select=register`)
  }
  const loginAccountCallback = (e) => {
    e.preventDefault()
    history.push(`${history.location.pathname}?a=checkout&step=account&select=login`)
  }
  return (<div className='of-checkout-account of-checkout-main'>
    <div className='of-checkout-account__wrapper of-checkout-account__wrapper--border lines-border-1-100'>
      <div className='of-checkout-account__heading text-font-1-100'>New to {getAppConfigValue('company_name')}?</div>
      <div className='of-checkout-account__description text-font-3-100'>Create a new account</div>
      <SolidButton onClick={createAccountCallback} className={'of-checkout-account__button'}>Create
        Account</SolidButton>
    </div>
    <div className={'of-checkout-account__wrapper'}>
      <div className='of-checkout-account__heading text-font-1-100'>Existing customer?</div>
      <div className='of-checkout-account__description text-font-3-100'>Log into your {getAppConfigValue('ccp_name')} account below</div>
      <OutlinedButton onClick={loginAccountCallback} className={'of-checkout-account__button'}>Login</OutlinedButton>
    </div>
  </div>)
}

Initial = withRouter(Initial)

Initial.propTypes = {
  history: PropTypes.any
}

let LoginForm = (props) => {
  const { handleSubmit,gobackURL } = props
  const getForgotLink = () => {
    if(window && window.app_config && window.app_config.ccp_link){
      return {
        label: 'Forgot?',
        link: window.app_config.ccp_link
      }
    }
    return null
  }
  return (
    <form onSubmit={handleSubmit} className={'of-checkout-account-login-form of-checkout-form'}>
      <div className={'of-checkout-account-login__heading text-font-1-100'}>Log into your account below</div>
      <div className={'of-checkout-form__row'}>
        <div className={'of-checkout-form__column of-checkout-form__column--full'}>
          <Field component={TextField} name={'email'} placeholder={'Email Address'}
                 validate={[requiredFieldValidation, emailFieldValidation]}
                  label={'Email Address'}
          />
        </div>
      </div>
      <div className={'of-checkout-form__row'}>
        <div className={'of-checkout-form__column of-checkout-form__column--full'}>
          <Field component={TextField}
                 name={'password'} type={'password'} placeholder={'Password'}
                 validate={[requiredFieldValidation]}
                 label={'Password'}
                 externalLink={getForgotLink()}
          />
        </div>
      </div>
      <SolidButton className={'of-checkout-account-login-form__button'} type={'submit'}>Login and continue</SolidButton>
      <Goback className={'of-checkout-form__goback'} url={`${gobackURL?gobackURL:'/?a=checkout&step=account'}`}>Go back</Goback>
    </form>
  )
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  gobackURL: PropTypes.string
}

LoginForm = reduxForm({
  form: 'LoginForm'
})(LoginForm)

let TwoFactorForm = (props) => {
  const { handleSubmit, login, setLogin, dispatch } = props
  const [request2fa, setRequest2fa] = useState({})
  const timeout = useRef(null)
  //init two factor
  useEffect(() => {
    if (request2fa.status === undefined) {
      setRequest2fa({
        ...request2fa,
        status: 'loading'
      })
      ACCOUNT_API.createTwoFactor().then(() => {
        ACCOUNT_API.getTwoFactorSettings().then(successresponse => {
          const data = getDataFromSuccessResponse(successresponse)
          if (timeout.current) {
            window.clearTimeout(timeout.current)
          }
          timeout.current = window.setTimeout(() => {
            setRequest2fa({
              ...request2fa,
              status: 'success',
              data
            })
          }, 500)
        }, errorresponse => {
          const error = getErrorFromFailResponse(errorresponse)
          setRequest2fa({
            ...request2fa,
            status: 'error',
            error
          })
        })
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        setRequest2fa({
          ...request2fa,
          status: 'error',
          error
        })
      })
    }
  }, [request2fa])

  const resend2FaCallback = (e) => {
    e.preventDefault()
    setRequest2fa({
      ...request2fa,
      status: 'loading',
      data: undefined,
      error: undefined
    })
    setLogin({
      ...login,
      data: undefined,
      error: undefined
    })
    ACCOUNT_API.createTwoFactor().then((successresponse) => {
      const data = getDataFromSuccessResponse(successresponse)
      setRequest2fa({
        ...request2fa,
        status: 'success',
        message: data.message ? data.message : 'Success'
      })
      setLogin({
        ...login,
        status: 'success',
        data
      })
      updatePopupNotification(dispatch, {
        status: 'success',
        data,
        error: null
      })

    }, (errorresponse) => {
      const error = getErrorFromFailResponse(errorresponse)
      setRequest2fa({
        ...request2fa,
        status: 'error',
        error
      })
      updatePopupNotification(dispatch, {
        status: 'success',
        error,
        data: null
      })
    })
  }

  const renderDescription = () => {
    const { status, data } = request2fa
    if (status === 'success') {
      if (data && data.length) {
        const getPrimaryMethod = () => {
          return data.find(item => {
            const { attributes } = item
            if (attributes) {
              const { is_primary } = attributes
              return is_primary === 1
            }
            return null
          })
        }
        if (getPrimaryMethod() && getPrimaryMethod().attributes) {
          const { method, method_value } = getPrimaryMethod().attributes
          switch (method) {
            case 'EMAIL':
              return <div className={'of-checkout-form__description text-font-3-100'}>Your verification code has been
                sent to {method_value}. Please enter it below to log into VIPControl</div>
            case 'SMS':
              return <div className={'of-checkout-form__description text-font-3-100'}>Your verification code has been
                sent to {method_value}. Please enter it below to log into VIPControl</div>
            default:
              return <></>
          }
        }
      }
    }
    return <></>
  }

  const { status } = request2fa
  if (status === undefined || status === 'loading') {
    return (
      <Loading/>
    )
  }
  return (
    <form className={'of-checkout-account-2fa-form of-checkout-form'} onSubmit={handleSubmit}>
      <div className={'of-checkout-form__heading'}>2 Factor Authentication</div>
      {renderDescription()}
      <div className={'of-checkout-form__row'}>
        <div className={'of-checkout-form__column of-checkout-form__colum--full'}>
          <Field name={'two_factor_token'} component={TextField} placeholder={'Enter two factor code'}
                 validate={[requiredFieldValidation]}/>
        </div>
      </div>
      <div className={'of-checkout-form__row'}>
        <div className={'of-checkout-form__column of-checkout-form__colum--full'}>
          <SolidButton type={'submit'} className={'of-checkout-account-2fa-form__button'}>Login and
            Continue</SolidButton>
        </div>
      </div>
      <div className={'of-checkout-form__row'}>
        <div
          className={'of-checkout-form__column of-checkout-form__colum--full of-checkout-account-2fa-form__resend-column'}>
          <button className={'of-checkout-account-2fa-form__resend primary-font-1-100'}
                  onClick={resend2FaCallback}>Resend verification code
          </button>
        </div>
      </div>
    </form>
  )
}


let SubAccountListForm = (props) =>{
  const dispatch = useDispatch()
  const {handleSubmit,subAccountList,history,redirectURL} = props
  const {status,data} = subAccountList
  const renderList = () => {
    if(status==='success' && data && data.length){
      const getInitials = (item) =>{
        let initials = ""
        const {firstname,lastname} = getAttributes(item)
        if(firstname && firstname.length){
          initials +=firstname[0]
        }
        if(lastname && lastname.length){
          initials +=lastname[0]
        }
        return initials
      }
      return data.map((item,index)=> {
        if(item && getAttributes(item)){
          const {id} = item
          const {firstname,lastname,account_type,company,is_your_account} = getAttributes(item)
          const renderYourAccountTag = () => {
            if(is_your_account){
              return (<div className={`of-sub-account-list-item__tag`}>Your Account</div>)
            }
            return(<></>)
          }
          const renderDetails = () =>{
            const renderContent = () => {
              if(account_type==="business" && company){
                return (<>
                  <div className={'of-sub-account-list-item__heading text-font-1-100'}>{company}</div>
                  <div className={'of-sub-account-list-item__sub-heading text-font-4-100'}>{firstname} {lastname}</div>
                </>)
              }
              return (<>
                <div className={'of-sub-account-list-item__heading text-font-1-100'}>{firstname} {lastname}</div>
              </>)
            }

            return (
              <div className={`of-sub-account-list-item__details${account_type?' of-sub-account-list-item__details--'+account_type:''}`}>
                {renderContent()}

              </div>
            )
          }
          return (<div key={index} onClick={()=>{handleSubmit(id)}} onMouseEnter={e=>{
            addClassToDOM(e.currentTarget,"shades-primary-background-1-100")
          }} onMouseLeave={e=>{
            removeClassToDOM(e.currentTarget,"shades-primary-background-1-100")
          }} className={"of-sub-account-list-item lines-border-1-100"}>
            <div className={'of-sub-account-list-item__initial'}>
              <div className={'of-sub-account-list-item__circle'}>
                {getInitials(item)}
              </div>
            </div>
            <div className={'of-sub-account-list-item__right'}>
              {renderDetails()}
              {renderYourAccountTag()}
            </div>
          </div>)
        }
        return (<div key={index} />)
      })
    }
    return (<></>)
  }
  const renderLoading = () => {
    if(status==="loading"){
      return (<Loading wrapper={true} className={'of-sub-account-list-form__loading'} />)
    }
    return (<></>)
  }
  const initFlag = useRef(false)
  const checkDataCallback = useCallback(() => {
    if(initFlag.current===false && status==="success"){
      if(!data || (data && data.length<=1)){
        redirectPage(history,redirectURL,'redirect')
      }
      initFlag.current = true
    }
  },[data,history,status,redirectURL])
  useEffect(()=>{
    checkDataCallback()
  },[checkDataCallback])
  return (
    <div className={'of-sub-account-list-form'} >
      <div className={'of-sub-account-list-form__heading of-heading text-font-1-100'}>Which account are you making<br />this purchase for?</div>
      <div className={`of-sub-account-list-form__list${status==="loading"?' of-sub-account-list-form__list--loading':''}`}>
        {renderList()}
        {renderLoading()}
      </div>
      <button onClick={()=>{logoutApp(dispatch,history)}} className={'of-checkout-user-details__link primary-font-1-100 of-sub-account-list-form__logout'}>Logout</button>
    </div>
  )
}

SubAccountListForm = withRouter(SubAccountListForm)

SubAccountListForm.propTypes={
  subAccountList: PropTypes.object,
  handleSubmit: PropTypes.func,
  history: PropTypes.object
}

TwoFactorForm.propTypes = {
  handleSubmit: PropTypes.func,
  login: PropTypes.any,
  setLogin: PropTypes.func,
  dispatch: PropTypes.func
}

TwoFactorForm = reduxForm({
  form: 'CheckoutTwoFactorForm'
})(TwoFactorForm)


const redirectPage = (history,url,type) => {
  const redirect = () => {
    if(url){
      history.push(`${history.location.pathname}${url}`)
    }else{
      history.push(`${history.location.pathname}?a=checkout&step=payment`)
    }
  }
  const goToAccountPage = () => {
    if(url){
      history.push(`${history.location.pathname}${url}`)
    }else{
      history.push(`${history.location.pathname}?a=checkout&step=account&select=login&list=true`)
    }
  }
  switch (type){
    case 'redirect':
      redirect()
      break
    case 'account':
      goToAccountPage()
      break;
    default:
      redirect()
  }
}


export let Login = (props) => {
  const dispatch = useDispatch()
  const { history,checkToken,location,accountURL,redirectURL,gobackURL } = props
  const {a} = getDataFromURL(location.search)
  const [login, setLogin] = useState({})
  const { status, flag } = login
  const [showTwoFactorForm, setShowTwoFactorForm] = useState(false)
  const prevCheckTokenStatus = useRef(undefined)
  const onLoadCallback = useCallback(()=>{
    if(prevCheckTokenStatus.current !== checkToken.status){
      if( checkToken.status==="success"){
        setLogin({
          ...login,
          status: 'success',
          flag: 'login-success',
          data: checkToken.data
        })
      }
      prevCheckTokenStatus.current = checkToken.status
    }
  },[checkToken,login])
  const refetchingCallback = useCallback(()=>{
    appInit(dispatch,history,false,true)
  },[dispatch,history])
  const [subAccountList,setSubAccountList] = useState({})


  const getSubAccListCallback = useCallback(() => {
    setSubAccountList({
      status: 'loading'
    })
    ACCOUNT_API.listAccounts().then(successResponse => {
      const data = getDataFromSuccessResponse(successResponse)
      if (data && Array.isArray(data) && data.length>1) {
        //history.push(`${history.location.pathname}?a=checkout&step=account&select=login&list=true`)
        redirectPage(history,accountURL,'account')
        setSubAccountList({
          status: 'success',
          data
        })
      } else {
        //history.push(`${history.location.pathname}?a=checkout&step=payment`)
        redirectPage(history,redirectURL,'redirect')
        setSubAccountList({
          status: 'error',
          data: undefined
        })
      }
    }, errorResponse => {
      const error = getErrorFromFailResponse(errorResponse)
      setSubAccountList({
        status: 'error',
        error
      })
    })
  }, [history,accountURL,redirectURL])
  useEffect(() => {
    onLoadCallback()
    if (status === 'success') {
      if (flag === 'login-success') {
        const { data } = login
        if (data && data.attributes) {
          const { attributes } = data
          const { token, two_factor_required } = attributes
          ACCOUNT_API.setAccessToken(token)
          if (two_factor_required) {
            setShowTwoFactorForm(true)
          } else {
            refetchingCallback()
            getSubAccListCallback()
          }
        }
      } else if (flag === '2fa-success') {
        refetchingCallback()
        getSubAccListCallback()
      }
    }
  }, [status, login, history, flag,refetchingCallback,getSubAccListCallback,onLoadCallback])
  const handleLogin = (payload) => {
    const { email, password } = payload
    setLogin({
      ...login,
      status: 'loading'
    })
    ACCOUNT_API.login(email, password).then(successResponse => {
      const data = getDataFromSuccessResponse(successResponse)
      setLogin({
        ...login,
        status: 'success',
        data,
        flag: 'login-success'
      })
      updatePopupNotification(dispatch, {
        status: 'success',
        data,
        error: null
      })
    }, errorResponse => {
      const error = getErrorFromFailResponse(errorResponse)
      setLogin({
        ...login,
        status: 'error',
        error
      })
      updatePopupNotification(dispatch, {
        status: 'error',
        data: null,
        error
      })
    })
  }
  const handleTwoFactor = (payload) => {
    const { two_factor_token } = payload
    setLogin({
      ...login,
      status: 'loading'
    })
    ACCOUNT_API.verifyTwoFactor(two_factor_token).then(successResponse => {
      const data = getDataFromSuccessResponse(successResponse)
      setLogin({
        ...login,
        status: 'success',
        data,
        flag: '2fa-success'
      })
      updatePopupNotification(dispatch, {
        status: 'success',
        data,
        error: null
      })
    }, errorResponse => {
      const error = getErrorFromFailResponse(errorResponse)
      setLogin({
        ...login,
        status: 'error'
      })
      updatePopupNotification(dispatch, {
        status: 'error',
        error,
        data: null
      })
    })
  }
  const handleSetAccount = (id) => {
    dispatch({
      type: ACCOUNT_LOADING
    })
    ACCOUNT_API.setAccountForlogin(id).then(()=>{
      dispatch({
        type: ACCOUNT_SUCCESS
      })
      //history.push(`${window.location.pathname}?a=checkout&step=payment`)
      redirectPage(history,redirectURL,'redirect')
    },errorresponse=>{
      const error = getErrorFromFailResponse(errorresponse)
      dispatch({
        type: ACCOUNT_ERROR
      })
      updatePopupNotification(dispatch,{
        status:"error",
        error
      })
    })
  }
  const renderLoading = () => {
    if (status === 'loading' || subAccountList.status==='loading' || checkToken.status==='loading') {
      return (
        <div className={'of-checkout-account-login__loading'}>
          <Loading className={'of-checkout-account-login__loading-icon'}/>
        </div>
      )
    }
    return (<></>)
  }
  const renderForm = () => {
    if(checkToken.status==="success" || checkToken.status==="error"
      || (a==='switch')
    ){
      if(status==="success"){
        if(flag==="login-success"){
          if (showTwoFactorForm) {
            return (<TwoFactorForm onSubmit={handleTwoFactor} setLogin={setLogin} login={login}/>)
          }
          if(subAccountList && subAccountList.status==="success"){
            return (<SubAccountListForm handleSubmit={handleSetAccount} redirectURL={redirectURL} subAccountList={subAccountList}/>)
          }
        }
        if(flag==="2fa-success"){
          if(subAccountList && subAccountList.status==="success"){
            return (<SubAccountListForm handleSubmit={handleSetAccount} redirectURL={redirectURL} subAccountList={subAccountList}/>)
          }
        }
      }
      return (<LoginForm onSubmit={handleLogin} gobackURL={gobackURL}/>)
    }
    return (<></>)
  }
  return (<>
      <div className={'of-checkout-account-login'}>
        {renderForm()}
        {renderLoading()}
      </div>
    </>
  )
}

Login = withRouter(Login)

Login.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  checkToken:PropTypes.object,
  accountURL:PropTypes.object,
  redirectURL:PropTypes.object,
  gobackURL:PropTypes.object
}

const confirmPasswordValidation = (value, allvalues) => {
  const { password, confirm_password } = allvalues
  if (password !== confirm_password) {
    return ('Passwords do not match')
  }
  return undefined
}

let RegisterForm = (props) => {

  const { form } = useSelector(state => ({ form: state.form }))

  const { handleSubmit, initialize } = props
  const initFlag = useRef(false)
  const prevEmailAddress = useRef(null)
  const token = getCartToken()
  const onBlurEmail = () => {
    if (cancelAddEmail) {
      cancelAddEmail()
    }
    if (form &&
      form.RegisterForm &&
      form.RegisterForm.values &&
      form.RegisterForm.values.email &&
      emailFieldValidation(form.RegisterForm.values.email) === undefined &&
      token
    ) {
      if (prevEmailAddress && prevEmailAddress.current !== form.RegisterForm.values.email) {
        ACCOUNT_API.addEmail(form.RegisterForm.values.email, token).then(() => {
          prevEmailAddress.current = form.RegisterForm.values.email
        }, () => {

        })
      }
    }

  }
  useEffect(() => {
    if (!initFlag.current) {
      if (localStorage.getItem('createAccount')) {
        const userDetails = JSON.parse(localStorage.getItem('createAccount'))
        initialize(userDetails)
        initFlag.current = true
      }
    }
  }, [initialize])
  return (<form className='of-checkout-form' onSubmit={handleSubmit}>
    <div className={'of-checkout-form__row'}>
      <div className={`of-checkout-form__column of-checkout-form__column--full`}>
        <Field label={'Email Address'} onBlur={onBlurEmail} component={TextField} name={'email'} placeholder={'Email Address'}
               validate={[requiredFieldValidation, emailFieldValidation]}/>
      </div>
    </div>
    <div className={'of-checkout-form__row'}>
      <div className={`of-checkout-form__column`}>
        <Field label={'First Name'} component={TextField} name={'firstname'} placeholder={'First Name'}
               validate={[requiredFieldValidation]}/>
      </div>
      <div className={`of-checkout-form__column`}>
        <Field label={'Last Name'} component={TextField} name={'lastname'} placeholder={'Last Name'} validate={[requiredFieldValidation]}/>
      </div>
    </div>
    <div className={'of-checkout-form__row'}>
      <div className={`of-checkout-form__column`}>
        <Field label={'Company Name'} component={TextField} name={'company_name'} placeholder={`Company Name`} optional={true}/>
      </div>
      <div className={`of-checkout-form__column`}>
        <Field label={'Phone'} component={TextField} name={'phone'} placeholder={`Phone Number`}
               validate={[requiredFieldValidation, phonenumberValidation, AU_NZ_phone_validation]}/>
      </div>
    </div>
    <div className={'of-checkout-form__row'}>
      <div className={`of-checkout-form__column`}>
        <Field label={'Password'} component={TextField} name={'password'} type="password" placeholder={`Password`}
               validate={[requiredFieldValidation, passwordValidation]}/>
      </div>
      <div className={`of-checkout-form__column`}>
        <Field label={"Confirm Password"} component={TextField} name={'confirm_password'} type="password" placeholder={`Re-enter Password`}
               validate={[requiredFieldValidation, confirmPasswordValidation]}/>
      </div>
    </div>
    <div className={'of-checkout-form__row'}>
      <div className={'of-checkout-terms text-font-1-100'}>By clicking the <strong>Sign Up</strong> button below, you
        agree to our <a href={getAppConfigValue('terms_link')} className={'text-font-1-100'}
                        target={'_blank'}>Terms, Policies & Agreements</a>
      </div>
    </div>
    <div className={'of-checkout-form__row'}>
      <div className={`of-checkout-form__column of-checkout-form__column--full`}>
        <SolidButton type='submit' className={'of-checkout-form__button'}>Sign Up</SolidButton>
      </div>
    </div>
    <Goback className={'of-checkout-form__goback'} url={'/?a=checkout&step=account'}>Go back</Goback>
  </form>)
}

RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialize: PropTypes.any
}

RegisterForm = reduxForm({
  form: 'RegisterForm'
})(RegisterForm)

let Register = (props) => {
  const { history } = props
  const [validateAccountDetails, setvalidateAccountDetails] = useState({})
  const dispatch = useDispatch()
  const registerCallback = (payload) => {
    setvalidateAccountDetails({
      ...validateAccountDetails,
      status: 'loading'
    })
    localStorage.setItem('createAccount', JSON.stringify(payload))
    globalCookies.remove('access_token')
    ACCOUNT_API.removeAccessToken()
    ACCOUNT_API.validateAccountDetails(payload).then(successresponse => {
      const data = getDataFromSuccessResponse(successresponse)
      setvalidateAccountDetails({
        ...validateAccountDetails,
        status: 'loading',
        data
      })
      appInit(dispatch,history,false,true)
     /* updatePopupNotification(dispatch, {
        status: 'success',
        data,
        error: null
      })*/

      window.setTimeout(() => {
        history.push(`${history.location.pathname}?a=checkout&step=payment`)
      }, 500)
    }, errorresponse => {
      const error = getErrorFromFailResponse(errorresponse)
      setvalidateAccountDetails({
        ...validateAccountDetails,
        status: 'error',
        error
      })
      updatePopupNotification(dispatch, {
        status: 'error',
        error,
        data: null
      })
    })
  }
  const { status } = validateAccountDetails
  const elementRef = useRef(null)
  const disableScrollCallback = useCallback(()=>{
    if(elementRef && elementRef.current && status){
      const {parentNode} = elementRef.current
      if(status==="loading" && parentNode){
        if(!parentNode.classList.contains("disable-scroll")){
          parentNode.classList.add("disable-scroll")
        }
      }else{
        if(parentNode.classList.contains("disable-scroll")){
          parentNode.classList.remove("disable-scroll")
        }
      }
    }
  },[elementRef,status])
  useEffect(()=>{
    disableScrollCallback()
  },[disableScrollCallback])
  return (
    <>
    <div className='of-checkout-account-register' ref={elementRef}>
      <div className='text-font-1-100 of-checkout-account-register__heading'>Create Account</div>
      <div className='text-font-3-100 of-checkout-account-register__description'>{`You're one step away from creating something awesome.`}</div>
      <RegisterForm onSubmit={registerCallback}/>

    </div>
      {status === 'loading' ? <Loading wrapper={true} /> : <></>}
    </>
  )
}

Register.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any
}

Register = withRouter(Register)

let Account = (props) => {
  const {accountStatus} = useSelector(state=>({
    accountStatus: state.app.accountStatus
  }))
  const { location, history } = props
  const { select,list} = getDataFromURL(location.search)
  const [checkToken, setCheckToken] = useState({})
  useEffect(() => {
    if (checkToken.status === undefined) {
      setCheckToken({
        ...checkToken,
        status: 'loading'
      })
      if (cancelCheckToken) {
        cancelCheckToken()
      }
      ACCOUNT_API.checkToken().then(successresponse => {
        if(list==="true" && select==="login"){
          const data = getDataFromSuccessResponse(successresponse)
          setCheckToken({
            ...checkToken,
            status: 'success',
            data
          })
        }else{
          const data = getDataFromSuccessResponse(successresponse)
          setCheckToken({
            ...checkToken,
            status: 'loading',
            data
          })
          window.setTimeout(() => {
            history.push(`${history.location.pathname}?a=checkout&step=payment`)
          }, 500)
        }
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        if (!isResponseCancelled(error)) {
          ACCOUNT_API.removeAccessToken()
          globalCookies.remove("access_token")
          setCheckToken({
            ...checkToken,
            status: 'error',
            error
          })
        }
      })
    }
  }, [history, checkToken,list,select])

  const { status } = checkToken
  const renderPage=  () =>{
    //check token here
    switch (select) {
      case 'register':
        return (<Register/>)
      case 'login':
        return (<Login checkToken={checkToken}/>)
      default:
        return (<Initial/>)
    }
  }
  return (<>
    {renderPage()}
    {status === undefined || status === 'loading' || accountStatus==='loading'?<Loading wrapper={true}/>:<></>}
  </>)
}

Account.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

Account = withRouter(Account)

export default Account
